import { Component, createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
class DefaultErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    this.props.onError?.(error, errorInfo);
  }
  render() {
    if (this.state.hasError) return this.props.fallback || null;
    return this.props.children;
  }
}
const ErrorBoundaryContext = /*#__PURE__*/createContext(DefaultErrorBoundary);
function ErrorBoundaryProvider({
  errorBoundaryComponent,
  children
}) {
  return /*#__PURE__*/jsx(ErrorBoundaryContext.Provider, {
    value: errorBoundaryComponent,
    children: children
  });
}
const useErrorBoundary = () => useContext(ErrorBoundaryContext);
export { DefaultErrorBoundary, ErrorBoundaryContext, ErrorBoundaryProvider, useErrorBoundary };
//# sourceMappingURL=ErrorBoundaryProvider.js.map
